// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from "@thd-olt-component-react/router";

const ssr = typeof window === "undefined";

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  home: {
    name: "home",
    componentName: "HomeHOC",
    chunk: () => import(
      /* webpackChunkName: "home" */
      "./pages/Home"
    ),
    get component() {
      return ssr
        // eslint-disable-next-line no-undef
        ? __webpack_require__(require.resolveWeak("@cwd/src/pages/Home.js")).HomeHOC
        : currentRouteName === "home"
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk() // eslint-disable-line
            .then((pageModule) => ({ default: pageModule.HomeHOC })));
    },
    path: "/:context?/myaccount/security",
    channel: null
  },
});